import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';
import Logger from '@evidentid/logger';
import Tracker from '@evidentid/tracker';

import DecisioningCriteria from '@/modules/decisioning-criteria/views/DecisioningCriteria.vue';
import RiskProfileView from '@/modules/decisioning-criteria/views/RiskProfileView.vue';
import { useDecisioningCriteriaStore } from '@/modules/decisioning-criteria/store';
import { observeTrackAndLogPerModule, TrackAndLogConfig } from '@/utils/vuex-common/observeTrackAndLogPerModule';

const legacyRoutesRedirect = [
    {
        path: '/:rpId?/decisioningCriteria',
        redirect: '/:rpId?/decisioning',
    }, {
        path: '/:rpId?/decisioningCriteria/group/',
        redirect: '/:rpId?/decisioning/riskProfile/',
    }, {
        path: '/:rpId?/decisioningCriteria/group/:id',
        redirect: '/:rpId?/decisioning/riskProfile/:id',
    },
];

function trackAndLog(app: any): void {
    const config: TrackAndLogConfig = {
        module: 'Decisioning',
        entries: [
            { subjectName: 'Criteria', action: 'Load' },
            { subjectName: 'Criteria', action: 'Patch' },
            { subjectName: 'CriterionMessage', action: 'Load' },
            { subjectName: 'CriterionTemplates', action: 'Load' },
            { subjectName: 'CurrentRiskProfile', action: 'Load' },
            { subjectName: 'RequirementModels', action: 'Load' },
            { subjectName: 'RequirementTypesPerCountry', action: 'Load' },
            { subjectName: 'RiskProfile', action: 'Create' },
            { subjectName: 'RiskProfile', action: 'Delete' },
            { subjectName: 'RiskProfile', action: 'Update' },
            { subjectName: 'RiskProfiles', action: 'Load' },
        ],
    };
    observeTrackAndLogPerModule(app, config, useDecisioningCriteriaStore(app.getPinia()));
}

export const decisioningCriteriaModule = createModuleBuilder()
    .registerRoutes(() => [
        {
            path: '/:rpId?/decisioning',
            name: 'decisioning',
            component: DecisioningCriteria as any,
            meta: { title: 'Decisioning', pageClass: 'DecisioningCriteria' },
        },
        {
            path: '/:rpId?/decisioning/riskProfile/',
            name: 'createDecisioningRiskProfile',
            component: RiskProfileView as any,
            meta: { title: 'Decisioning', pageClass: 'RiskProfileView overflow-hidden-y' },
        },
        {
            path: '/:rpId?/decisioning/riskProfile/:id',
            name: 'decisioningRiskProfile',
            component: RiskProfileView as any,
            meta: { title: 'Decisioning', pageClass: 'RiskProfileView overflow-hidden-y' },
        },
        ...legacyRoutesRedirect,
    ])
    .demandContext<{
    gatewayClient: GatewayApiClient;
    tracker?: Tracker<any>;
    logger?: Logger<any>;
}>()
    .execute((app) => {
        trackAndLog(app);
    })
    .end();
